import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel} from '../../shared';
import {GenericDocContainerModel} from '../../../../../../models/aggregates/generic_doc';
import { BaseGenDocTypeService } from './base-generic-doc-hdr.service';

@Injectable({
  providedIn: 'root'
})
export class InternalJobOrderService extends BaseGenDocTypeService {

  constructor(http: HttpClient) {
    // super();
    // this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}internal-job-orders`;
    // this.httpClient = http;
    super(http, 'internal-job-orders')
  }

  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }
}
